import React from 'react';
import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="hero">
      <div className="hero-content">
        <h1>The perfect gift, ready to play</h1>

        {/* Image moved inside content so it can align with the top of the first paragraph */}
        <picture className="hero-media">
          {/* Optional WebP sources:
          <source
            type="image/webp"
            srcSet="/images/mom-kid-slideshow.webp 1x, /images/mom-kid-slideshow@2x.webp 2x"
            sizes="(min-width: 1024px) 40vw, (min-width: 768px) 45vw, 100vw"
          /> */}
          <img
            src="/images/mom-kid-slideshow.jpeg"
            alt="FotoMate device showing a family slideshow"
            loading="lazy"
            className="hero-image"
          />
        </picture>

        <p>
          When you gift someone a fotomate<sup>&reg;</sup>, you’re giving more than a slideshow—you’re giving
          a living, evolving memory machine that grows with you and your loved ones.
        </p>

        <h2>Personalized and effortless</h2>
        <p>
          Your personalized fotomate<sup>&reg;</sup> gift arrives with your photos and videos already installed,
          ready to play from the moment it’s unboxed. Memories that you already forgot are magically revisited
          and the story begins to grow from there!<br />
          <div className="button-group"><a
            href="https://photomanager.photomate.com"
            className="button btn-secondary"
            target="_blank"
            rel="noopener noreferrer"
          >
            Build&nbsp;your&nbsp;FotoMate&nbsp;now!
          </a></div>
        </p>

        <h2>Bring families closer</h2>
        <p>
          fotomate<sup>&reg;</sup> becomes part of your daily life, bringing your family closer by displaying distant memories, family milestones, good times, and adventures. There's no scrolling or forever searching for those perfect moments to build the "perfect slideshow".<br /><br /> 
          <b>fotomate<sup>&reg;</sup> makes ALL of your memories useful and fun!</b>
        </p>

        <h2>A companion powered by AI</h2>
        <p>
          And because every fotomate<sup>&reg;</sup> includes a customizable AI assistant, your memories become
          interactive. It remembers details you’ve shared, helps you rediscover forgotten moments, and even sparks
          new conversations—transforming your slideshow into a true companion on your family’s journey.
        </p>

        <div className="button-group">
          <Link to="/products" className="button btn-primary">
            Shop&nbsp;FotoMate&nbsp;Products
          </Link>
          
        </div>
      </div>

      <style>{`
        .hero {
          padding: 1.25rem;
        }

        .hero-content {
          max-width: 70ch;
          margin: 0 auto;
        }

        .hero-content h1 {
          margin: 0 0 0.55rem 0;
          line-height: 1.1;
        }

        /* Decrease subheader size by ~2px and tighten spacing */
        .hero-content h2 {
          font-size: 20px; /* typically ~22px default -> reduced by ~2px */
          margin: 1.5rem 0 0.25rem 0; /* tighter space above & below */
          line-height: 1.2;
        }

        /* Decrease paragraph size by ~2px and line-height */
        .hero-content p {
          font-size: 14px; /* typically 16px default -> reduced by 2px */
          line-height: 1.35; /* slightly tighter */
          margin: 0.4rem 0;  /* a bit tighter vertical rhythm */
        }

        .button-group {
          display: flex;
          flex-wrap: wrap;
          gap: 0.6rem;
          margin-top: 0.9rem;
        }

        /* Image defaults (mobile-first): full width above text, no float */
        .hero-media {
          display: block;
          margin: 0 0 0.75rem 0; /* space below image on mobile */
        }

        .hero-image {
          width: 100%;
          height: auto;
          border-radius: 12px;
          object-fit: cover;
          box-shadow: 0 8px 24px rgba(0,0,0,0.12);
          max-width: 520px; /* keeps it reasonable on large phones */
        }

        /* Tablet and up: float image right and align its top with the top of the first paragraph */
        @media (min-width: 768px) {
          .hero {
            padding: 2rem;
          }

          .hero-content {
            max-width: 1000px;
          }

          .hero-media {
            float: right;                  /* text wraps around */
            margin: 0 0 0.75rem 1.25rem;   /* space to the left and bottom of image */
            width: 42%;                    /* image occupies ~2/5 of content area */
          }

          .hero-image {
            display: block;
            width: 100%;
            max-width: none;               /* allow width to be controlled by .hero-media */
          }
        }

        /* Desktop refinements */
        @media (min-width: 1024px) {
          .hero {
            padding: 3rem 2.5rem;
          }

          .hero-media {
            width: 40%;
            margin-left: 1.5rem;
            margin-bottom: 1rem;
          }
        }

        /* Clear float at the end of content flow to contain wrapping */
        .hero-content::after {
          content: "";
          display: table;
          clear: both;
        }
      `}</style>
    </section>
  );
}
